var exports = {
  "y": "AutocompleteMention.module__divider___bGJ0Xz",
};

module.exports = exports;
